var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("SMS Campaign Overview")]),(_vm.campaign.id)?_c('sms-campaign-details',{attrs:{"campaign":_vm.campaign}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }